import { Component } from '@angular/core';
import { BaseAdvancedPropertyViewComponent } from '../base-advanced-property-view.component';
import { WallComponent } from 'src/app/models/components/objectComponents/WallComponent';
import { MatDialogRef } from '@angular/material/dialog';
import { InputHelper } from 'src/app/helper/inputHelper';

@Component({
  selector: 'app-wall',
  templateUrl: './wall.component.html',
  styleUrls: ['./wall.component.css']
})
export class WallViewComponent extends BaseAdvancedPropertyViewComponent {
  // currently not used since the wall object has no specific properties
  wall: WallComponent;
  label1:string = 'Height';
  integerOnly = InputHelper.integerOnly;

  constructor(public dialogRef: MatDialogRef<BaseAdvancedPropertyViewComponent>) {
    super(dialogRef);
    dialogRef.disableClose = true;
  }

  ngOnInit() {
  }

  saveButtonDisabledState():boolean{
    return false;
  }
}
